import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { noop } from 'lodash';
import { breakpoint } from '@zocdoc/components/src/grid';
import styled from 'styled-components';
import { TakeoverModal } from '@zocdoc/components/src/TakeoverModal';
import { ModalButtonContainer, ModalHeader } from '@zocdoc/components/src/modal';
import { Button } from '@zocdoc/components/src/button';
import PropTypes from 'prop-types';
import { DefaultValues, LOCALIZED_STRINGS, SortingEnum } from '../constants';
import { grey10, navy, white } from '@zocdoc/branding/colors';
import { FontFamily } from '@zocdoc/components/src/typography';

export class SortingTakeover extends React.Component {
    static propTypes = {
        changeSortingEnabled: PropTypes.func,
        exitSortByTakeover: PropTypes.func,
        onApplySort: PropTypes.func,
        sortTypeSelected: PropTypes.string,
        theme: PropTypes.object,
        updateParameters: PropTypes.func,
    };

    static defaultProps = {
        changeSortingEnabled: noop,
        exitSortByTakeover: noop,
        onApplySort: noop,
        sortTypeSelected: DefaultValues.sortType,
        theme: {},
        updateParameters: noop,
    };

    state = {
        selectedValue: this.props.sortTypeSelected,
    };

    render() {
        return (
            <SortByTakeoverModal
                onClickCancel={this.applySortingOption}
            >
                <ModalContent>
                    <ModalScrollableArea>
                        <StyledModalHeader>
                            <FormattedMessage
                                {...LOCALIZED_STRINGS.SortingDropdownTitle}
                            />
                        </StyledModalHeader>
                        {this.renderOptions()}
                    </ModalScrollableArea>
                    <ModalButtonContainer>
                        <Button
                            data-test="facet-modal-apply-button"
                            onClick={this.applySortingOption}
                        >
                            apply
                        </Button>
                    </ModalButtonContainer>
                </ModalContent>
            </SortByTakeoverModal>
        );
    }

    renderOptions() {
        const { theme } = this.props;
        return (
            <div>
                {theme.search.config.sortingOptions.map(key => SortingEnum[key] && (
                    this.renderSortingOption(SortingEnum[key])
                ))}
            </div>
        );
    }

    renderSortingOption(sortingEnum) {
        return (
            <SortingModalOption
                key={sortingEnum.name}
                data-option-selected-value={sortingEnum.value}
                data-test={`faceted-search-sorting-${sortingEnum.name}`}
            >
                <SortingModalOptionLabel>
                    <StyledInput
                        checked={sortingEnum.value === this.state.selectedValue}
                        data-option-selected-value={sortingEnum.value}
                        data-test="sorting-takeover-radio"
                        onChange={this.handleChangeRadio}
                        type="radio"
                    />
                    {sortingEnum.text}
                </SortingModalOptionLabel>
            </SortingModalOption>
        );
    }

    handleChangeRadio = e => {
        const enumValue = e.target.getAttribute('data-option-selected-value');
        if (enumValue !== this.state.selectedValue) {
            this.setState({ selectedValue: enumValue });
        }
    }

    applySortingOption = () => {
        this.props.onApplySort();
        this.props.updateParameters({
            sortType: this.state.selectedValue,
        });
        this.handleExitSortByTakeover();
        if (this.state.sortType === DefaultValues.sortType) {
            this.props.changeSortingEnabled(false);
        } else {
            this.props.changeSortingEnabled(true);
        }
    }

    handleExitSortByTakeover = () => {
        this.props.exitSortByTakeover();
    }
}

const SortByTakeoverModal = styled(TakeoverModal)`
    -webkit-overflow-scrolling: touch;
    position: absolute;
    z-index: 100;

    ${breakpoint.small} {
        display: none;
    }
`;

const ModalContent = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
`;

const ModalScrollableArea = styled.div`
    flex: 1 1 auto;
    overflow: auto;
`;

const StyledModalHeader = styled(ModalHeader)`
    flex: 0 1 auto;
`;

const SortingModalOption = styled.div`
    background: ${white};
    color: ${navy};
    cursor: pointer;
    display: flex;
    font: 13px ${FontFamily.SharpSansMedium};
    padding-left: 18px;
    padding: 5px 2px 5px;
    width: 100%;
    &:hover {
        background-color: ${grey10};
    }
`;

const SortingModalOptionLabel = styled.label`
    color: ${navy};
    font: 15px ${FontFamily.SharpSansMedium};
    margin-right: 16px;
    white-space: nowrap;

    &:hover {
        cursor: pointer;
    }
`;

const StyledInput = styled.input`
    margin-right: 10px;
`;

export default injectIntl(SortingTakeover);
